import { BookingTolerancesListItem } from "../../../integrated-client/models/";

interface ITableData {
  records: Array<BookingTolerancesListItem>;
  totalItems: number;
}

export class TableData implements ITableData {
  records: Array<BookingTolerancesListItem>;
  totalItems: number;

  constructor() {
    this.records = [];
    this.totalItems = 0;
  }
}
